import React, { useState } from "react";
import { Card, Row, Col, Dropdown, Form, Button } from "react-bootstrap";

const ChoosePlans = () => {

  const [yearly, setYearly] = useState(false);

  const plans = [
    {
      name: "Basic",
      price: yearly ? 500 : 50,
      employees: "10 Employees",
      projects: "50 Projects",
      clients: "50 Clients",
      storage: "50 GB Storage",
      chat: false,
      crm: false
    },
    {
      name: "Advanced",
      price: yearly ? 2000 : 200,
      employees: "50 Employees",
      projects: "100 Projects",
      clients: "100 Clients",
      storage: "50 GB Storage",
      chat: true,
      crm: false
    },
    {
      name: "Premium",
      price: yearly ? 3000 : 300,
      employees: "100 Employees",
      projects: "200 Projects",
      clients: "100 Clients",
      storage: "100 GB Storage",
      chat: true,
      crm: false
    },
    {
      name: "Enterprise",
      price: yearly ? 4000 : 400,
      employees: "Unlimited Employees",
      projects: "Unlimited Projects",
      clients: "Unlimited Clients",
      storage: "Unlimited Storage",
      chat: true,
      crm: true
    }
  ];

  return (
    <>

      {/* Header */}
      <Card className="mb-3">
        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap">

            <h5 className="mb-0">Plans List</h5>

            <div className="d-flex gap-2">

         <Dropdown>
  <Dropdown.Toggle
    variant="light"
    style={{
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      padding: "6px 14px",
      fontSize: "14px",
      background: "#fff"
    }}
  >
    Select Plan
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item>Basic</Dropdown.Item>
    <Dropdown.Item>Advanced</Dropdown.Item>
    <Dropdown.Item>Premium</Dropdown.Item>
    <Dropdown.Item>Enterprise</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>


<Dropdown>
  <Dropdown.Toggle
    variant="light"
    style={{
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      padding: "6px 14px",
      fontSize: "14px",
      background: "#fff"
    }}
  >
    Sort By : Last 7 Days
  </Dropdown.Toggle>

  <Dropdown.Menu>
    <Dropdown.Item>Recently Added</Dropdown.Item>
    <Dropdown.Item>Ascending</Dropdown.Item>
    <Dropdown.Item>Descending</Dropdown.Item>
    <Dropdown.Item>Last Month</Dropdown.Item>
    <Dropdown.Item>Last 7 Days</Dropdown.Item>
  </Dropdown.Menu>
</Dropdown>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Plans */}
      <Card>
        <Card.Body>

          {/* Monthly / Yearly Switch */}
          <div className="d-flex justify-content-center align-items-center mb-4">

            <p className="mb-0 me-2">Monthly</p>

            <Form.Check
              type="switch"
              checked={yearly}
              onChange={() => setYearly(!yearly)}
            />

            <p className="mb-0 ms-2">Yearly</p>

          </div>

          <Row className="justify-content-center">

            {plans.map((plan, index) => (

              <Col lg={3} md={6} sm={12} key={index} className="d-flex mb-4">

                <Card className="flex-fill">

                  <Card.Body>

                    {/* Plan Header */}
                    <Card className="mb-3">
                      <Card.Body>
                        <h4>{plan.name}</h4>

                        <h1>
                          ${plan.price}
                          <span className="fs-6 text-muted">
                            /{yearly ? "yearly" : "monthly"}
                          </span>
                        </h1>
                      </Card.Body>
                    </Card>

                    {/* Features */}
                    <div className="p-3 bg-light rounded mb-3">

                      <h6 className="text-muted mb-3">Features Includes</h6>

                      <p>
                        <i className="ti ti-discount-check-filled text-success me-2"></i>
                        {plan.employees}
                      </p>

                      <p>
                        <i className="ti ti-discount-check-filled text-success me-2"></i>
                        {plan.projects}
                      </p>

                      <p>
                        <i className="ti ti-discount-check-filled text-success me-2"></i>
                        {plan.clients}
                      </p>

                      <p>
                        <i className="ti ti-discount-check-filled text-success me-2"></i>
                        {plan.storage}
                      </p>

                      <p>
                        <i className={`ti ${plan.chat ? "ti-discount-check-filled text-success" : "ti-circle-x-filled text-danger"} me-2`}></i>
                        Voice & Video Chat
                      </p>

                      <p>
                        <i className={`ti ${plan.crm ? "ti-discount-check-filled text-success" : "ti-circle-x-filled text-danger"} me-2`}></i>
                        CRM
                      </p>

                    </div>

                    <Button variant="dark" className="w-100">
                      Choose Plan
                    </Button>

                  </Card.Body>

                </Card>

              </Col>

            ))}

          </Row>

        </Card.Body>
      </Card>

    </>
  );
};

export default ChoosePlans;